import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ChatComponent } from './support/chat/chat.component';
import { AuthGuard } from './services/auth.guard';
import { GuestGuard } from './services/guest.guard';
import { SupportGuard } from './services/support.guard';
import { FrontGuard } from './services/front.guard';
import { VTuberAuthGuard } from './services/vtuber.guard';
import { HomeComponent } from './home/home.component';
import { TopComponent } from "./top/top.component";
import { LoginComponent } from "./auth/login/login.component";
import { RegisterComponent } from "./auth/register/register.component";
import { PasswordComponent } from "./auth/password/password.component";
import { PrivacyComponent } from "./static/privacy/privacy.component";
import { TermsComponent } from "./static/terms/terms.component";
import { ProfileComponent } from "./settings/profile/profile.component";
import { AvatarCallComponent } from './avatar/call/call.component';
import { ReserveListComponent } from './reserve/list/list.component';
import { ReserveCancelComponent } from './reserve/cancel/cancel.component';
import { NotificationComponent } from './support/notification/notification.component';
import { CallTestComponent } from './avatar/call-test/call-test.component';
import { MaintenanceComponent } from './static/maintenance/maintenance.component';

// Normal User
import { SupportIndexComponent } from "./support/index/index.component";
import { SupportCardComponent } from "./support/card/card.component";
import { SettingCardComponent } from "./settings/card/card.component";
import { ChatRoomComponent } from './support/room/room.component';
import { SupportPlansComponent } from './support/plans/plans.component';
import { SupportPlanItemComponent } from './support/plans/item/item.component';
import { SupportHistoryComponent } from './support/history/history.component';
import { SettingCardDetailComponent } from './settings/card-detail/card-detail.component';
import { SupportVtubersComponent } from './support/vtubers/vtubers.component';
import { AvatarSelectComponent } from './avatar/select/select.component';
import { AvatarConfirmComponent } from './avatar/confirm/confirm.component';
import { ReserveAddComponent } from './reserve/add/add.component';
import { ReserveConfirmComponent } from './reserve/confirm/confirm.component';

// VTuber
import { VTuberRegisterComponent } from "./vtuber/auth/register/register.component";
import { VTuberHomeComponent } from './vtuber/home/home.component';
import { VTuberProfileComponent } from './vtuber/profile/profile.component';
import { VTuberSupportCreateComponent } from './vtuber/support/create/create.component';
import { VTuberSupportPreviewComponent } from './vtuber/support/preview/preview.component';
import { VtuberNotificationComponent } from './vtuber/notification/notification.component';
import { VTuberCallTimesComponent } from './vtuber/call/times/times.component';
import { VTuberSupportersComponent } from "./vtuber/support/list/list.component";
import { VTuberHistoryComponent } from "./vtuber/history/history.component";
import { VTuberBankComponent } from './vtuber/profile/bank/bank.component';
import { VTuberBankEditComponent } from './vtuber/profile/bank/edit/edit.component';
import { NewsComponent } from './static/news/news.component';
import { LawComponent } from './static/law/law.component';

const routes: Routes = [
  // { path: '', component: TopComponent },
  { path: '', redirectTo: 'avatar/select', pathMatch: 'full'},
  // { path: 'about', component: TopComponent },
  // { path: 'privacy', component: PrivacyComponent },
  // { path: 'terms', component: TermsComponent },
  // { path: 'faq', component: NewsComponent },
  // { path: 'law', component: LawComponent },
  // { path: 'login', component: LoginComponent, canActivate: [GuestGuard] },
  // { path: 'register', component: RegisterComponent, canActivate: [GuestGuard] },
  // { path: 'password/forgot', component: PasswordComponent, canActivate: [GuestGuard] },
  // { path: 'home', component: HomeComponent, canActivate: [SupportGuard]},
  { path: 'profile', component: ProfileComponent, canActivate: [SupportGuard] },
  { path: 'chat/:id', component: ChatComponent, canActivate: [AuthGuard] },
  { path: 'notification', component: NotificationComponent, canActivate: [AuthGuard] },
  { path: 'rooms', component: ChatRoomComponent, canActivate: [AuthGuard] },
  { path: 'avatar/call/:uid', component: AvatarCallComponent, canActivate: [AuthGuard] },
  { path: 'avatar/call-test', component: CallTestComponent },

  // Normal User
  // { path: 'support/:uid', component: SupportIndexComponent, canActivate: [FrontGuard] },
  { path: 'card/pay', component: SupportCardComponent, canActivate: [SupportGuard] },
  { path: 'settings/card', component: SettingCardComponent, canActivate: [SupportGuard] },
  { path: 'settings/card/detail', component: SettingCardDetailComponent, canActivate: [SupportGuard] },
  { path: 'user/plans', component: SupportPlansComponent, canActivate: [SupportGuard] },
  { path: 'user/plan/view', component: SupportPlanItemComponent, canActivate: [SupportGuard] },
  { path: 'user/histories', component: SupportHistoryComponent, canActivate: [SupportGuard] },
  // { path: 'user/vtubers', component: SupportVtubersComponent, canActivate: [SupportGuard] },
  { path: 'avatar/select', component: AvatarSelectComponent },
  { path: 'avatar/confirm', component: AvatarConfirmComponent },
  { path: 'reserve/add', component: ReserveAddComponent, canActivate: [SupportGuard] },
  { path: 'reserve/confirm', component: ReserveConfirmComponent, canActivate: [SupportGuard] },
  { path: 'reserve/list', component: ReserveListComponent, canActivate: [AuthGuard] },
  { path: 'reserve/cancel/:uid', component: ReserveCancelComponent, canActivate: [AuthGuard] },

  // VTuber
  // { path: 'vtuber/register', component: VTuberRegisterComponent, canActivate: [GuestGuard] },
  { path: 'vtuber/mlpnkobjivhucgyxftzdraseqw', component: VTuberRegisterComponent, canActivate: [GuestGuard] },
  // { path: 'vtuber/home', component: VTuberHomeComponent, canActivate: [VTuberAuthGuard] },
  { path: 'vtuber/profile', component: VTuberProfileComponent, canActivate: [VTuberAuthGuard] },
  { path: 'vtuber/support', component: VTuberSupportCreateComponent, canActivate: [VTuberAuthGuard] },
  { path: 'vtuber/support/preview', component: VTuberSupportPreviewComponent, canActivate: [VTuberAuthGuard] },
  { path: 'vtuber/notification', component: VtuberNotificationComponent, canActivate: [VTuberAuthGuard] },
  { path: 'vtuber/call/times', component: VTuberCallTimesComponent, canActivate: [VTuberAuthGuard] },
  { path: 'vtuber/supporters', component: VTuberSupportersComponent, canActivate: [VTuberAuthGuard] },
  { path: 'vtuber/history', component: VTuberHistoryComponent, canActivate: [VTuberAuthGuard] },
  { path: 'vtuber/profile/bank', component: VTuberBankComponent, canActivate: [VTuberAuthGuard] },
  { path: 'vtuber/profile/bank/edit', component: VTuberBankEditComponent, canActivate: [VTuberAuthGuard] }
];

// // メンテナンス中の表示
// const routes: Routes = [
//   {path: '**', component: MaintenanceComponent}
// ];

// メンテナンス中の表示
// const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
